export const API_BASE_URL = (import.meta.env.VITE_API_BASE_URL ?? 'http://localhost:3200').replace(/\/$/, '');

export const API_V1_BASE_URL = `${API_BASE_URL}/api/v1`;
